module.exports = __webpack_public_path__ + "main/assets/public/player-media-session/playing-256.0678eb16059e306a.jpg";